var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.91 13.718.057-.026.031-.055 5.521-9.562a2.188 2.188 0 0 0-.77-2.966l-.038-.044h-.039a2.003 2.003 0 0 0-.429-.177 2.169 2.169 0 0 0-1.179-.012A2.175 2.175 0 0 0 8.738 1.89l-5.522 9.566-.032.054.006.063.301 3.444.025.285.259-.12 3.135-1.464ZM9.535 2.195c.434-.572 1.146-.724 1.736-.404l.034.019c.597.345.837 1.057.553 1.726L9.535 2.195Zm1.918 2.066-4.848 8.398a5.284 5.284 0 0 0-2.345-1.354l4.848-8.398 2.345 1.354ZM4.24 14.05l-.168-1.937c.706.19 1.413.598 1.93 1.115l-1.762.822Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.0be5f3a345af8e82ea84df2cbec81ab5.svg";
export { ForwardRef as ReactComponent };